<template>
  <div>Logged in at {{ row.createdOn | formatDateTime }}</div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "login-activity-inner-node",
  props: {
    row: {
      type: Object
    }
  }
});
</script>
